import { CalculationBet } from '../../pages/my-bets/types/my-bets.type'
import { ExposureService } from '../services/exposure.service'
import { HelperService } from '../services/helper.service'

/**
 * Calculate total exposure for non-odds bet types (double chance, asian handicap, goal lines, line)
 */
export function calculateTotalExposureForBets(bets: CalculationBet[], helperService: HelperService, exposureService: ExposureService): number {
	if (bets.length === 0) return 0

	const doubleChanceBets = bets.filter((bet) => helperService.isDoubleChanceBet(bet))
	const asianHandicapBets = bets.filter((bet) => helperService.isAsianHandicapBet(bet))
	const goalLineBets = bets.filter((bet) => helperService.isGoalLinesBet(bet))
	const lineBets = bets.filter((bet) => helperService.isLineBet(bet))

	const asianHandicapMarketsMarketGroupIds = Array.from(new Set(asianHandicapBets.map((bet) => bet.marketGroupId)))
	const goalLineMarketsMarketGroupIds = Array.from(new Set(goalLineBets.map((bet) => bet.marketGroupId)))
	const doubleChanceMarketsMarketGroupIds = Array.from(new Set(doubleChanceBets.map((bet) => bet.marketGroupId)))
	const lineMarketsUniqueIds = Array.from(new Set(lineBets.map((bet) => `${bet.marketId}-${bet.selectionId}`)))

	const asianHandicapTotalExposure = asianHandicapMarketsMarketGroupIds.reduce(
		(sum, id) => sum + exposureService.calculateAsianHandicapBasedExposure(asianHandicapBets, id),
		0,
	)
	const goalLineTotalExposure = goalLineMarketsMarketGroupIds.reduce((sum, id) => sum + exposureService.calculateGoalLinesBasedExposure(goalLineBets, id), 0)
	const doubleChanceTotalExposure = doubleChanceMarketsMarketGroupIds.reduce(
		(sum, id) => sum + exposureService.calculateDoubleChanceBasedExposure(doubleChanceBets),
		0,
	)
	const lineTotalExposure = lineMarketsUniqueIds.reduce((sum, id) => sum + exposureService.calculateRunnerBasedExposure(lineBets, id), 0)

	return asianHandicapTotalExposure + goalLineTotalExposure + doubleChanceTotalExposure + lineTotalExposure
}
